import { put } from 'redux-saga/effects';
import { Notifications } from 'types';

import { addNoticeAction } from 'core/widgets/Notices/actions';
import { Notices } from 'core/widgets/Notices/types';
import { OnTableNotificationData } from '../types';

export function* onTableNotificationSaga({
  type: notificationType,
  data: result,
}: OnTableNotificationData) {
  if (notificationType === Notifications.NOTIFICATION) {
    if (result.notifyAbout === 'CLOSE_GAME') {
      yield put(addNoticeAction({ notification: Notices.CloseTableInProgress }));
      return;
    }
    if (result.notifyAbout === 'SHUFFLE') {
      return;
    }
  }
}
